import { useMappingDrillDown } from '@/context/MappingDrillDownContext';
import { searchContext } from '@/context/Context';
import { useCurrentMappingLevel } from '@/store/mappingStackStore';
import type { SearchContext } from '@/types';

/** Resolves GDA/VDA for timeline fetch: mapping drill-down tab wins over parent search tab. */
export function useResolvedAssociationTab(): string {
  const { tab } = (searchContext() ?? {}) as SearchContext;
  const { effectiveTab } = useMappingDrillDown();
  const currentMappingLevel = useCurrentMappingLevel();
  const mappingTabSegment = currentMappingLevel?.mappingContent?.tabSegment;

  return String(effectiveTab || mappingTabSegment || tab || '').toUpperCase();
}
